import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
} from '@mui/material';
import { HomeOutlined as Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 6,
          textAlign: 'center',
          backgroundColor: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography 
            variant="h1" 
            component="h1" 
            sx={{ 
              fontSize: '6rem',
              fontWeight: 500,
              color: '#a31830',
              mb: 2,
              lineHeight: 1,
            }}
          >
            404
          </Typography>
          
          <Typography 
            variant="h4" 
            component="h2" 
            gutterBottom 
            sx={{ 
              fontWeight: 500,
              color: '#2d3748',
              mb: 2,
            }}
          >
            Page Not Found
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ 
              fontSize: '1.1rem',
              mb: 4,
              maxWidth: '500px',
              mx: 'auto',
            }}
          >
            The page you're looking for doesn't exist or has been moved. 
            Let's get you back on track.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<Home />}
            onClick={handleGoHome}
            sx={{
              backgroundColor: '#a31830',
              color: 'white',
              fontWeight: 500,
              px: 4,
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: '#8b1426',
              },
            }}
          >
            Go to Home
          </Button>
          
          <Button
            variant="outlined"
            size="large"
            onClick={handleGoBack}
            sx={{
              borderColor: '#a31830',
              color: '#a31830',
              fontWeight: 500,
              px: 4,
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                borderColor: '#8b1426',
                color: '#8b1426',
                backgroundColor: 'rgba(163, 24, 48, 0.04)',
              },
            }}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFound;